@if (config.settings.enableExperimentalWorkflow) {
  <main [class]="showLoginInfo() ? 'card auth-card shadow' : ''">
    <div [class]="showLoginInfo() ? 'login-area' : ''">
      @if (showLoginInfo()) {
        <img
          class="company-logo"
          [src]="'/assets/trimble-maps-logo.svg'"
          alt=""
        />
      }

      @if (showLoginInfo() && showAppName()) {
        <h1 class="application-name">
          {{ config.textMap.appName }}
        </h1>
      }

      <div style="width: 100%">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
} @else {
  <main class="card auth-card shadow overflow-hidden">
    @if (showBrandInfo()) {
      <div class="brand-text-area">
        <span class="app-description">{{ config.textMap.appDescription }}</span>
        <span class="app-tagline">{{ config.textMap.appTagline }}</span>
      </div>
    }

    <div class="login-area">
      <img
        class="company-logo"
        [src]="'/assets/trimble-maps-logo.svg'"
        alt=""
      />

      @if (showAppName()) {
        <h1 class="application-name">
          {{ config.textMap.appName }}
        </h1>
      }

      <div style="width: 100%">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
}
